import React from "react";
import { Radio } from "antd";

const YesNo = ({
	defaultValue,
	dispatch,
	name,
	questionId,
	dataType,
	...otherProps
}) => {
	const [answerAdded, answerEdited] = dispatch;
	const onChange = (e) => {
		let data = {
			questionId: questionId,
			value: e.target.value,
			id: name,
			dataType: dataType,
		};
		if (defaultValue) answerEdited(data);
		else answerAdded(data);
	};
	return (
		<Radio.Group onChange={onChange} value={defaultValue} {...otherProps}>
			<Radio value={"Yes"}>Yes</Radio>
			<Radio value={"No"}>No</Radio>
		</Radio.Group>
	);
};

export default YesNo;
